import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Icon from "@/components/common/Icon/Icon.tsx";

interface MainHeroButtonsProps {
  btnClass: string;
}

const MainHeroButtons = ({ btnClass }: MainHeroButtonsProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div
      className={
        "responsive-transition absolute bottom-[3.125rem] right-[3.625rem] flex gap-5 max-2xl:bottom-8 max-xl:bottom-5 max-xl:right-5 max-lg:hidden"
      }
    >
      <button
        type={"button"}
        title={t("navigation.previous-slide")}
        className={`responsive-transition js-${btnClass}-prev group z-[1] rounded-full bg-gradient-2 p-5 hover:bg-on-primary`}
      >
        <Icon
          name={"arrow-left"}
          className={"responsive-transition size-6 stroke-on-primary group-hover:stroke-orange-1"}
        />
      </button>
      <button
        type={"button"}
        title={t("navigation.next-slide")}
        className={`responsive-transition js-${btnClass}-next group z-[1] rounded-full bg-gradient-2 p-5 hover:bg-on-primary`}
      >
        <Icon
          name={"arrow-right"}
          className={"responsive-transition size-6 stroke-on-primary group-hover:stroke-orange-1"}
        />
      </button>
    </div>
  );
};

export default MainHeroButtons;
